<template>
     <div style="height: calc(100vh - 60px);">
    <v-row v-if="has_error && is_created">
        <v-col style="
            justify-content: center;
            display: flex;
            flex-direction: column;
            align-items: center;
        ">
            <div
                style="
                    font-size: 20px;
                    font-weight: 500;
                    padding: 20px;
                "
            >Projeto não encontrado</div>
            <div>
                <v-btn @click="() => $router.push('/projects')">Voltar</v-btn>
            </div>
        </v-col>
    </v-row>
    <div v-else-if="!has_error" >
        
        <v-row>
  <v-col>
    <v-card
      class="project-card"
      outlined
    >
      <v-skeleton-loader
        v-if="!is_created"
        type="table-heading, table-heading"
        aria-label="Carregando informações do projeto"
      ></v-skeleton-loader>

      <v-row>
        <v-col cols="1">
          <v-btn  v-if="is_created" style="
            border-radius: 20px 0px 0px 20px; 
            background-color: #D3D3D3; 
            width: 50px; 
            height: 100%;" 
            @click="goBack"
          >
            <v-icon 
              x-large
              style="   
                color: white;
              "
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </v-col>
        <v-col cols="11">
          <template v-if="is_created">
            <!-- Informações principais -->
            <v-row>
              <v-col :cols="changeColSize" v-if="changeColSize === 4">
                <div class="project-info">
                  <IconContainer
                    icon="mdi-card-account-details-outline"
                    :size="40"
                    :iconSize="24"
                  />
                  <div>
                    <span class="info-title">Franqueado</span>
                    <span class="info-value">{{ project.franchisee_name_formatted }}</span>
                  </div>
                </div>
              </v-col>
              <v-col :cols="changeColSize">
                <div class="project-info">
                  <IconContainer
                    icon="mdi-folder"
                    :size="40"
                    :iconSize="24"
                  />
                  <div>
                    <span class="info-title">Nome do Projeto</span>
                    <span class="info-value">{{ project.project_name }}</span>
                  </div>
                </div>
              </v-col>
              <v-col :cols="changeColSize">
                <div class="project-info">
                  <IconContainer
                    icon="mdi-calendar"
                    :size="40"
                    :iconSize="24"
                  />
                  <div>
                    <span class="info-title">Criado em</span>
                    <span class="info-value">{{ project.created_at_formatted }}</span>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <!-- Informações do cliente -->
            <v-row>
              <v-col :cols="changeColSize" >
                <div class="project-info">
                  <IconContainer
                    icon="mdi-account"
                    :size="40"
                    :iconSize="24"
                  />
                  <div>
                    <span class="info-title">Nome do Cliente</span>
                    <span class="info-value">{{ project.lead_name }}</span>
                  </div>
                </div>
              </v-col>
              <v-col :cols="changeColSize">
                <div class="project-info">
                  <IconContainer
                    icon="mdi-card-text"
                    :size="40"
                    :iconSize="24"
                  />
                  <div>
                    <span class="info-title">Documento do Cliente</span>
                    <span class="info-value">{{ project.lead_document }}</span>
                  </div>
                </div>
              </v-col>
              <v-col :cols="changeColSize" v-if="changeColSize === 4">
                <div class="project-info">
                  <IconContainer
                    icon="mdi-book-outline"
                    :size="40"
                    :iconSize="24"
                  />
                  <div>
                    <span class="info-title">Nº Matrícula</span>
                    <span class="info-value">{{ project.registration }}</span>
                  </div>
                </div>
              </v-col>
            </v-row>
          </template>
        </v-col>
      </v-row>
    </v-card>
  </v-col>
</v-row>



        <v-container style="padding: 0px;">
        <v-row class="d-flex justify-center align-center" style="min-height: 60vh;">
        <div
            v-for="(step, index) in options"
            :key="index"
            id="btn-styles-options"
        >  
            <div class="step-wrapper">
                <div class="icon-container-2">
                    <div
                    class="icon-container"
                    @click="openStep(step.name)"
                    :style="{
                        backgroundColor: isDisabled(step) ? 'grey' : step.color ,
                        cursor: isDisabled(step) ? 'not-allowed' : 'pointer',
                        pointerEvents: isDisabled(step) ? 'none' : 'auto'
                        }"
                    >
                    <div class="step-content">
                        <img
                            :src="step.icon"
                            alt="Step Icon"
                            class="step-icon"
                        />
                        <span class="step-description">{{ step.description }}</span>
                    </div>
                    </div>
                </div>
            </div>
        </div>
        </v-row>
        </v-container>

        <Prospecting 
            v-if="openProspection" 
            :openModal="openProspection"
            :idLead="project.id_lead"
            :idProject="project.id_doc"
            :closeFunc="closeFunc"
            :currentStep="currentStep"
        
        />
        <Diagnostic
            v-if="openDiagnostic" 
            :idLead="project.id_lead"
            :openModal="openDiagnostic"
            :closeFunc="closeFunc"
            :idProject="project.id_doc"
            :idDiagnostic="project.id_diagnostic"
            :currentStep="currentStep"
        />
        <Approval
            v-if="openApproval" 
            :openModal="openApproval"
            :closeFunc="closeFunc"
            :idProject="project.id_doc"
            :idLead="project.id_lead"
            :idDiagnostic="project.id_diagnostic"
            :currentStep="currentStep"
        />

        <Closing
          v-if="openClosing" 
          :openModal="openClosing"
          :closeFunc="closeFunc"
          :idLead="project.id_lead"
          :idProject="project.id_doc"
          :idDiagnostic="project.id_diagnostic"
          :currentStep="currentStep"
        />
        
        <Contract
            v-if="openContract" 
            :openModal="openContract"
            :closeFunc="closeFunc"
            :idProject="project.id_doc"
            :idLead="project.id_lead"
            :idContract="project.id_contract"
            :currentStep="currentStep"
        />

        <Closing
            v-if="openClosing" 
            :openModal="openClosing"
            :closeFunc="closeFunc"
            :idProject="project.id_doc"
            :idDiagnostic="project.id_diagnostic"
            :currentStep="currentStep"
        />


        <Materials
            v-if="openMaterials"
            :openModal="openMaterials"
            :closeFunc="closeFunc"
            :idProject="project.id_doc"
            :idMaterials="project.id_material"
            :currentStep="currentStep"
        />

        <Installation
            v-if="openInstallation"
            :openModal="openInstallation"
            :closeFunc="closeFunc"
            :idProject="project.id_doc"
            :idInstallation="project.id_installation"
            :currentStep="currentStep"
        />

        <v-dialog transition="dialog-top-transition" v-model="modal" v-if="modal" max-width="700px" :persistent=saving_configs_loading>
            <v-card>
              <v-card-title class="primary lighten white--text">
                Configurações do Projeto
                <v-spacer></v-spacer>

                <v-btn text class="litte white--text" @click="() => modal = false">
                  <v-icon white>mdi-window-close</v-icon>

                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-tabs v-model="tab">
                  <v-tab v-for="selectedTab in tabItems" :key="selectedTab">{{ selectedTab }}</v-tab>
                </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-tab-item key="1">
                          <v-col cols="12">
                            <v-row>
                              <v-checkbox
                                  color="success"
                                  v-model="project.configs.wpp_notification"
                                  label="Notificações no Whatsapp (Atualizações do Projeto)"></v-checkbox>
                            </v-row>
                            <v-row v-if="!project.configs.wpp_notification" style="margin-top: -15px; margin-left: 32px;">
                                <span class="helper-text" style="color: red;">
                                    Isso pode levar a atrasos no progresso do seu projeto, use com cautela.
                                </span>
                            </v-row>
                          </v-col>
                        <v-divider></v-divider>
                        <div style="padding: 10px; display: flex; justify-content: end;">
                          <v-btn text :loading="saving_configs_loading" @click="updateProjectConfigs">
                            Salvar
                          </v-btn>
                        </div>
                    </v-tab-item>

                    <v-tab-item key="2">
                    <v-timeline dense>
                    <v-slide-x-reverse-transition
                        group
                        hide-on-leave
                    >
                        <v-timeline-item
                            v-for="(item,index) in items"
                            :key="index"
                            :color="item.type"
                            small
                            fill-dot
                            :icon="item.icon"
                            >
                            <v-alert
                                :value="true"
                                :color="item.type"
                                :icon="item.icon"
                                class="white--text"
                            >
                                {{ `${item.stepName} - ${item.status} - ${item.userName || " / "} `}} <br> {{ item.date }}
                            </v-alert>
                        </v-timeline-item>
                    </v-slide-x-reverse-transition>
                    </v-timeline>
                    </v-tab-item>

                    <v-tab-item key="3" v-if="getCurrentUserRank !== 'Franqueado'">
                      <v-col cols="12">
                        <v-autocomplete 
                            label="Franqueado" 
                            persistent-hint 
                            v-model="form.id_franchisee"
                            :items="project_franchisee_list" 
                            item-text="name" 
                            item-value="id"
                            return-object 
                            single-line
                            :disabled="is_loading"
                            @change="handleFranchiseeChange">
                        </v-autocomplete>
                          </v-col>
                        <div style="padding: 10px; display: flex; justify-content: end;">
                          <v-btn text :loading="saving_configs_loading" @click="changeFrachiseeProject">
                            Mudar Responsável
                          </v-btn>
                        </div>
                    </v-tab-item>

                    <v-tab-item key="4" v-if="getCurrentUserRank !== 'Franqueado'">
                      <!-- Notify Configs-->
                      <NotificationReceptors
                        v-model="selected_notification_receptors"
                        :notificationReceptorsList="notification_receptors_list"
                        :isLoading="is_loading"
                        :savingConfigsLoading="saving_configs_loading"
                        :getReceptorById="getReceptorById"
                        :getReceptorAlertsCount="getReceptorAlertsCount"
                        @save="saveNotificationReceptors"
                        @config="openReceptorConfig"
                      />
                    </v-tab-item>
                    
                  </v-tabs-items>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Modal de Configuração de Alertas por Receptor -->
        <NotificationReceptorConfig
          v-if="currentReceptorConfig"
          v-model="configDialog"
          :receptorId="currentReceptorConfig.id"
          :receptorName="currentReceptorConfig.name"
          :currentStatuses="currentReceptorConfig.statuses"
          @save="saveReceptorConfig"
          @close="configDialog = false"
        />
        
        <v-fab-transition>
            <v-btn
                color="primary"
                dark
                absolute
                bottom
                right
                fab
                @click="openModalLog"
            >
                <v-icon>mdi-cog</v-icon>
            </v-btn>
        </v-fab-transition>
    </div>
</div>
</template>
  
<script>
import ProjectDetailsScript from "./ProjectDetailsScript.js";
export default ProjectDetailsScript;
</script>
  
<style scoped>
#btn-styles-options {
  display: flex;
  justify-content: center;
  align-items: center;
}

.step-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.step-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 100%;
  width: 100%;
}

.step-description {
  color: white;
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  max-width: 90px;
  word-wrap: break-word;
  line-height: 1.2;
}

.icon-container-2 {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 110px;
  width: 110px;
  border-radius: 30%;
  position: relative;
  margin: 0 4px;
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90px;
  width: 90px;
  background-color: #1976d2;
  border-radius: 20px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  padding: 8px;
}

.step-icon {
  max-width: 40%;
  max-height: 40%;
  position: relative;
}

.project-card {
  border-radius: 20px;
  width: 100%;
  margin: 0 !important;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}

.project-info {
  margin-bottom: 16px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.info-icon {
  font-size: 24px;
}

.info-title {
  color: rgb(99, 169, 255);
  font-weight: 500;
  font-size: 16px;
  display: block;
}

.info-value {
  font-weight: 400;
  font-size: 14px;
  display: block;
  color: var(--v-primary-base);
  margin-top: 4px;
}
</style>